import ContextMenu from 'flow/components/ContextMenu';
import CallWidgetMenuItems from 'flow/components/context-menus/CallWidgetMenuItems';
import Icon from 'flow/components/ui-components/Icon';
import { Tooltip } from 'flow/components/ui-components/Tooltip';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { selectCallRecordFromKey } from 'flow/selectors/call-selectors';

interface Props {
    callRecordKey: CallRecordKey;
}

const CallRecordWidgetContextMenu = ({ callRecordKey }: Props) => {
    const { i18next } = useAppContext();
    const callRecord = useAppSelector((state) =>
        selectCallRecordFromKey(state, callRecordKey),
    );

    if (!callRecord) return null;

    return (
        <Tooltip label={i18next.t('settings.callrouting.call_widgets')}>
            <ContextMenu
                triggerLabel={i18next.t('settings.callrouting.call_widgets')}
                icon={
                    <Icon iconKey="widgets" className="size-4 text-gray-500" />
                }
                placement="bottom-end"
                className="rounded bg-transparent p-0.5 hover:bg-gray-200"
            >
                <CallWidgetMenuItems callRecord={callRecord} />
            </ContextMenu>
        </Tooltip>
    );
};

export default CallRecordWidgetContextMenu;
